import React, { useState, useEffect, useRef } from "react";
import { AUDIO_FILE_BASE_URL } from "../../../../constants/general";
import { showToast } from "../../../../utils/general";

const AudioPlayer = ({
  id,
  isLoading,
  thirdParty,
  src,
  autoFetch = true,
  btnClassName,
  setCurrentPlayingVoice,
  currentPlayingVoice,
}) => {
  const [playing, setPlaying] = useState(false);
  const [blob, setBlob] = useState("");
  const [load, setLoad] = useState(autoFetch);

  const url = src ? (thirdParty ? src : AUDIO_FILE_BASE_URL + src) : "";

  const audioRef = useRef(null);

  useEffect(() => {
    setPlaying(false);
    if (src && load) {
      fetch(url, {
        cache: "no-cache",
      })
        .then(async (res) => {
          const blob = await res.blob();
          const test = new Blob([blob], { type: "audio/mp3" });
          const blobUrl = URL.createObjectURL(test);
          setBlob(blobUrl);
        })
        .catch((err) => {
          console.log(err, "Error while playing voice");
          showToast(
            "Currently, this voice is not supported. Please try again after sometime or try with another voice.U+1F64F",
            "",
            "danger"
          );
        });
    }
  }, [src, load]);

  useEffect(() => {
    // if autofetch is off means audio is load on play button click so should be autoplay once load
    if (!autoFetch && blob && !!audioRef.current) {
      setPlaying(true);
      audioRef.current.play();
      if (setCurrentPlayingVoice) {
        setCurrentPlayingVoice(id);
      }
    }
  }, [load, audioRef, blob]);

  useEffect(() => {
    if (currentPlayingVoice) {
      if (currentPlayingVoice !== id && playing) {
        audioRef.current.pause();
        setPlaying(false);
      }
    }
  }, [currentPlayingVoice, playing, audioRef]);

  const buttonClick = () => {
    if (!load) {
      setLoad(true);
    }
    if (!blob) {
      return;
    }

    setPlaying((prev) => !prev);
    if (playing) {
      audioRef.current.pause();
    } else {
      if (setCurrentPlayingVoice) {
        setCurrentPlayingVoice(id);
      }
      audioRef.current.play();
    }
  };

  return (
    <div>
      <button
        onClick={buttonClick}
        className={`${
          !blob && load ? "opacity-50 cursor-not-allowed" : ""
        } inline-flex items-center px-4 py-2 text-sm font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 ${
          btnClassName || ""
        }`}
      >
        {!load ? (
          "Play"
        ) : !blob || isLoading ? (
          <span className="loader-small"></span>
        ) : playing ? (
          "Pause"
        ) : (
          "Play"
        )}
      </button>
      {blob && (
        <audio
          hidden
          ref={audioRef}
          key={"hello"}
          controls
          preload="true"
          onEnded={() => setPlaying(false)}
          autoPlay={!autoFetch && !!load} // will autoplay if autoFetch is off & audio is loaded
        >
          <source src={blob} type="audio/mp3" />
        </audio>
      )}
    </div>
  );
};

export default AudioPlayer;
